import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { DoctorsClient } from "../web-api-client";
import { fetchWithTimeout } from "../utils/fetchWithTimeout";
import { wrapFetchWithSignal } from "../utils/abort";
import { appConfig } from "../appconfig";

export function useDoctorProfile(doctorId?: string) {
  return useQuery({
    queryKey: ["doctor-profile", doctorId],
    enabled: !!doctorId,                 // chỉ gọi khi có id
    placeholderData: keepPreviousData,   // giữ data cũ khi đổi id
    staleTime: 60_000,                   
    gcTime: 5 * 60_000,
    retry: (failureCount, error: any) => {
      // không retry nếu là AbortError
      if (error?.name === "AbortError") return false;
      return failureCount < 2;
    },
    refetchOnWindowFocus: false,
    queryFn: async ({ signal }) => {
      const client = new DoctorsClient(appConfig.apiBaseUrl, {
        fetch: wrapFetchWithSignal(fetchWithTimeout(), signal),
      });
      return client.getDoctorProfile(doctorId!);
    },
    select: (data) => data, 
  });
}
